import { useRouter } from 'next/router';

import AccessScreen from './AccessScreen';
import NewPasswordScreen from './NewPasswordScreen';
import SMSScreen from './SMSScreen';
import useForgetPasswordHook from '../hooks/useForgetPasswordHook';

type Screens = {
  [key: string]: JSX.Element;
};

const RecoverPasswordFlow = () => {
  const {
    sendOtpSms,
    verificationCode,
    setVerificationCode,
    VerifyOtpSms,
    newPassword,
    newRePassword,
    setnewPassword,
    setnewRePassword,
    updatePassword,
    loggedUserData,
    error,
  } = useForgetPasswordHook();
  const router = useRouter();

  const SCREENS: Screens = {
    'new-password': (
      <NewPasswordScreen
        password={newPassword}
        setPassword={setnewPassword}
        confirmPassword={newRePassword}
        setConfirmPassword={setnewRePassword}
        clickConnexion={updatePassword}
        error={error['new-password']}
      />
    ),
    access: (
      <AccessScreen
        phoneNumber={loggedUserData?.phonenumber}
        onClickPasswordMethod={() =>
          router.push({
            query: {
              ...router.query,
              screen: 'password',
            },
          })
        }
        onClickSmsMethod={sendOtpSms}
        forgetPassword={true}
        error={error?.access}
      />
    ),
    sms: (
      <SMSScreen
        verifyCode={verificationCode}
        setVerifyCode={setVerificationCode}
        reSendVerificationCode={sendOtpSms}
        handleNextClick={VerifyOtpSms}
        error={error.sms}
      />
    ),
    // 'new-user': <NewUserScreen error={error['new-user']} />,
  };
  const { screen } = router.query;
  const screenName = screen?.toString() || 'access';
  return <>{SCREENS[screenName]}</>;
};

export default RecoverPasswordFlow;
